import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useGenericGet from "../../../hooks/common/useGenericGet";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import { REVENUE_LEDGER_API, REVENUE_LEDGER_CSV_API, REVENUE_LEDGER_EXCEL_API } from "../../../constants/api";
import useRevenueLedger from "../../../hooks/payments/useRevenueLedger";

const RevenueLedgerRegister = () => {
  const location = useLocation();
  const [filters, setFilter] = useState({});
  const { loadData: getLedger, data: ledger, loading } = useGenericGet();

  const { ledgerTableData, ledgerTableColumns } = useRevenueLedger();

  useEffect(() => {
    getLedger({ api: REVENUE_LEDGER_API, params: filters });
  }, [location, filters]);

  if (loading) return <Loader />;

  return (
    <div>
      <Table
        tableData={ledgerTableData(ledger?.cumulative_report|| [])}
        tableColumns={ledgerTableColumns}
        tableTitle="Tax Head Ledger"
        loading={loading}
        count={ledger?.count}
        onFilterChange={setFilter}
        filters={filters}
        excelDownloadApi={REVENUE_LEDGER_EXCEL_API}
        csvDownloadApi={REVENUE_LEDGER_CSV_API}
      />
    </div>
  );
};

export default RevenueLedgerRegister;
